import { render, staticRenderFns } from "./PromoCodes.vue?vue&type=template&id=00da78ca&"
import script from "./PromoCodes.vue?vue&type=script&lang=ts&"
export * from "./PromoCodes.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VSelect})
